<form [formGroup]="menuService?.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3"
    [ngClass]="{'py-5 position-relative': isDialog}">
    <div class="container-fluid">
        <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
            (click)="dialogRef.close()"></i>
        <h4 *ngIf="isDialog" class="text-bold text-center px-3">
            Tipo de vehículo
        </h4>
        <div class="row" *ngIf="canEditVehicleService">
            <p class="col-12 my-3">
                <span class="text-bold">Vehículo {{menuService.isEscortedService() ? ' del escolta' : ''}}</span>
            </p>
            <div class="col-12 p-0 d-flex flex-wrap">
                <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>Alias del vehículo<span class="optional">(opcional)</span></mat-label>
                    <mat-select [formControl]="vehicleAliasControl" (selectionChange)="onSelectVehicleAlias($event)"
                        [compareWith]="compareWithVehicleAlias">
                        <mat-option *ngFor="let alias of vehicleAliases" [value]="alias">
                            {{alias?.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <app-type-vehicle class="col-md-6" [inputFormControl]="vehicleTypeControl" [options]="optionsTypeVehicle"
                [validate]="formValidate">
            </app-type-vehicle>
            <mat-form-field appearance="outline" class="col-md-6" *ngIf="showAxlesControl">
                <mat-label>N° de ejes<span class="asterisk">*</span></mat-label>
                <input type="number" min="2" matInput [formControl]="axlesControl"
                    (change)="onChangeVehicleAxles($event)">
                <mat-error *ngIf="axlesControl.errors?.min">
                    {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED_SHORT', 'N° de ejes', minAxles) }}
                </mat-error>
                <mat-error *ngIf="axlesControl?.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
            </mat-form-field>
            <app-vehicle-body-work-type class="col-md-6" [inputFormControl]="bodyworkTypeControl"
                [options]="optionsBodyworkType" [validate]="formValidate">
            </app-vehicle-body-work-type>
            <div class="col-md-6" *ngIf="showEnvironmentControl">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tipo de ambiente <span class="asterisk">*</span></mat-label>
                    <mat-select [formControl]="environmentControl">
                        <mat-option *ngFor="let environment of environments" [value]="environment.value">
                            {{environment.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="environmentControl?.errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-6" *ngIf="showTrailerInfo">
                <app-vehicle-body-work-type [inputFormControl]="trailerBodyworkControl"
                    [options]="optionsTrailerBodyworkType" [validate]="formValidate">
                </app-vehicle-body-work-type>
            </div>
            <mat-form-field appearance="outline" class="col-md-6" *ngIf="showTrailerInfo">
                <mat-label>N° de ejes del tráiler<span class="optional">(opcional)</span></mat-label>
                <input type="number" min="2" matInput [formControl]="trailerAxlesControl">
                <mat-error *ngIf="trailerAxlesControl.errors?.min">
                    {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED_SHORT', 'N° de ejes del tráiler', minAxles) }}
                </mat-error>
            </mat-form-field>
        </div>
        <div *ngIf="!canEditVehicleService" class="no-permission-container">
            <i class="fas fa-exclamation-circle fa-lg m-2"></i>
            <h4 class="text-bold">No tienes permiso para acceder a esta información. Contacta a tu administrador para
                solicitar acceso.</h4>
        </div>
        <div class="button-container mt-4" *ngIf="!isDialog; else dialogButtons">
            <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small"
                [ngClass]="{'warn': true}" type="button" (click)="backToPreviousStep()">
                <span class="mat-button-wrapper">Atras</span>
            </button>
            <button class="mx-2" type="submit" mat-raised-button color="accent" *ngIf="canEditVehicleService">
                Guardar y Continuar
            </button>
            <button class="mx-2" type="button" mat-raised-button color="accent" (click)="continueToNextStep()"
                *ngIf="!canEditVehicleService">
                Continuar
            </button>
        </div>
        <ng-template #dialogButtons>
            <div class="button-container mt-4">
                <button class="mx-2" type="submit" mat-raised-button color="accent">
                    Guardar
                </button>
            </div>
        </ng-template>
    </div>
</form>